<template>
  <div class="full-screen" style="z-index: 10;">
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">消费记录</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>

    <div v-if="hasData" class="mt25">
      <ul class="records-list">
        <li class="list-title"><span>2019-09</span></li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第16章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第17章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第18章</p>
            </div>
          </div>
        </li>

        <li class="list-title"><span>2019-08</span></li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第16章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第17章</p>
            </div>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item-l">
            周五<br/>09-20
          </div>
          <div class="list-item-r">
            <div>
              <p class="f14">
                名侦探柯南
                <span class="p-blue">-60金币</span>
              </p>
              <p class="f12">第18章</p>
            </div>
          </div>
        </li>

      </ul>
    </div>

    <div v-else class="mt25">
      <div class="h400">
        <div class="no_book">
          <p>暂时没有记录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "purchase-history",
    data() {
      return {
        hasData: true
      }
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      }
    },
    mounted() {
      this.$router.isBack = true;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/purchase-history.vue